module.exports = __webpack_public_path__ + "static/media/profile-image-new.6b3bbff1.jpg";